<template>
  <div>
    <div class="customization-panel-toggler" v-bind:class="{ opened: panelEnabled }" @click="togglePanel">
      <img src="/images/svg/cog.svg"/>
    </div>
    <div class="customization-panel" v-bind:class="{ opened: panelEnabled }">
      <div class="close-panel">
        <img src="/images/svg/global/arrow-right-r.svg" @click="togglePanel" class="close-icon"/>
        <img src="/images/save.png"  @click="saveCustomization" class="save-icon" v-bind:class="{saving: customizationIsSaving}" v-if="!isCustomizationSaved"/>
      </div>
      <div class="custom-settings">
        <custom-option title="Color Option" :doClose="closeDirection" @closeAll="closeAll">
          <div>
            <color-picker v-for="(val, key) in customizationLocal.colors" :style_name="key" :style_color="val"></color-picker>
          </div>
        </custom-option>
        <custom-option title="RTL" :doClose="closeDirection" @closeAll="closeAll">
          <div>
            <toggle-button v-model="textDirection" :labels="{checked: 'LTR', unchecked: 'RTL'}"/>
          </div>
        </custom-option>
        <custom-option title="Header settings" :doClose="closeDirection" @closeAll="closeAll">
          <div>
            Top bar availability
            <toggle-button :width="150" :sync="true" v-model="customizationLocal.topbar_availability" :labels="{checked: 'With Topbar', unchecked: 'Without Topbar'}"/>
            Logo position
            <toggle-button :width="150" :sync="true" v-model="customizationLocal.topbar_logo_position" :labels="{checked: 'Left Logo', unchecked: 'Center Logo'}"/>
          </div>
        </custom-option>
        <custom-option title="Slider section" :doClose="closeDirection" @closeAll="closeAll">
          <div>
            <toggle-button :width="150" :sync="true" v-model="customizationLocal.slider_availability" :labels="{checked: 'Slider Enabled', unchecked: 'Slider Disabled'}"/>
            <toggle-button :width="150" :sync="true" v-model="customizationLocal.slider_multiimage" :disabled="!customizationLocal.slider_availability" :labels="{checked: 'Multi Image Slider', unchecked: 'Single Image Slider'}"/>
          </div>
        </custom-option>
        <custom-option title="Title setting" :doClose="closeDirection" @closeAll="closeAll">
          <div>
            <toggle-button :width="150" :sync="true" v-model="customizationLocal.title_availability" :labels="{checked: 'With Title', unchecked: 'Without Title'}"/>
          </div>
        </custom-option>
        <custom-option title="App settings" :doClose="closeDirection" @closeAll="closeAll">
          <div>
            <toggle-button :width="150" :sync="true" v-model="customizationLocal.app_section_availability" :labels="{checked: 'With App', unchecked: 'Without App'}"/>
            Image Order
            <toggle-button :width="150" :sync="true" v-model="customizationLocal.app_section_image_order" :labels="{checked: 'Left Side', unchecked: 'Right Side'}"/>
          </div>
        </custom-option>
        <custom-option title="Footer section" :doClose="closeDirection" @closeAll="closeAll">
          <div>
            <toggle-button :width="150"  :sync="true" v-model="customizationLocal.footer_main_availability" :labels="{checked: 'Main Footer Enabled', unchecked: 'Main Footer Disabled'}"/>
            <toggle-button :width="150"  :sync="true" v-model="customizationLocal.footer_sub_availability" :labels="{checked: 'Sub Footer Enabled', unchecked: 'Sub Footer Disabled'}"/>
          </div>
        </custom-option>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import ColorPicker from "@/components/Elements/ColorPicker.vue";
  import CustomOption from "@/components/Elements/CustomOption";

  export default {
    name: 'CustomizationPanel',
    components: {CustomOption, ColorPicker},
    computed: {
      ...mapGetters(['_T', 'current_colors', 'customizationLocal', 'isCustomizationSaved', 'customizationIsSaving']),
    },
    methods: {
      togglePanel() {
        this.panelEnabled = !this.panelEnabled
        this.closeDirection = undefined
      },
      closeAll(caller_title){
        this.closeDirection = caller_title
      },
      saveCustomization(){
        if (!this.customizationIsSaving) {
          this.$store.dispatch('saveCustomization')
        }
      }
    },
    watch: {
      textDirection(val) {
        document.body.style.direction = val ? 'ltr' : 'rtl';
      }
    },
    data() {
      return {
        panelEnabled: false,
        closeDirection: undefined,
        toggleSlider: true,
        textDirection: true
      }
    }
  }
</script>

<style lang="scss" scoped>

  .customization-panel-toggler {
    img {
      width: 32px;
      margin-right: 4px;
      transition: all 0.5s;
      -webkit-transition: all 0.25s;

      &:hover {
        transform: rotate(90deg);
      }
    }

    opacity: 1;
    background: white;
    border-bottom-left-radius: 8px;
    border-top-left-radius: 8px;
    border: 0.3rem solid white;
    border-right: 0;
    position: fixed;
    top: 13rem;
    right: 0;
    z-index: 10;
    -webkit-box-shadow: -3px 3px 5px 0px rgba(0, 0, 0, 0.75);
    -moz-box-shadow: -3px 3px 5px 0px rgba(0, 0, 0, 0.75);
    box-shadow: -3px 3px 5px 0px rgba(0, 0, 0, 0.75);

    &.opened {
      opacity: 0;
      animation-name: openLeftPanel;
      animation-duration: 0.25s;
    }
  }

  @keyframes openLeftPanel {from {right: -12rem;}to {right: 0;}}
  @keyframes closeLeftPanel {from {right: 0;}to {right: -12rem;}}

  .customization-panel {
    overflow-y: scroll;
    width: 12rem;
    background-color: white;
    position: fixed;
    top: 0;
    height: 100vh;
    z-index: 10;
    opacity: 0;
    right: -12rem;

    &.opened {
      right: 0;
      opacity: 1;
      animation-name: openLeftPanel;
      animation-duration: 0.25s;
      -webkit-box-shadow: -3px 3px 5px 0px rgba(0, 0, 0, 0.75);
      -moz-box-shadow: -3px 3px 5px 0px rgba(0, 0, 0, 0.75);
      box-shadow: -3px 3px 5px 0px rgba(0, 0, 0, 0.75);
    }

    .close-panel {
      position: absolute;
      left: 0;
      width: 100%;

      img {
        margin: 0.5rem;
        width: 24px;
        height: 24px;
      }

      @keyframes blink{
        0%{opacity: 0;}
        50%{opacity: .5;}
        100%{opacity: 1;}
      }

      .save-icon{
        float: right;
        &.saving{
          animation: blink 1s linear infinite;
        }
      }

      .close-icon {

        transition: all 0.5s;
        -webkit-transition: all 0.15s;
        cursor: pointer;

        &:hover {
          transform: translate(0.5rem);
        }

      }
    }

    .custom-settings {
      margin-top: 3rem;
    }
  }
</style>
